

/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Common/IValidationProps" />
export interface IValidationProps {
    validationScopeId: string;
}
